export const tabs = {
  tabsSectionSelector: '.js-tabs',
  tabsTitlesSelector: '.js-tabs-titles',
  tabsTitleSelector: '.js-tab-title',
  tabsBodiesSelector: '.js-tabs-bodies',
  tabsBodysSelector: '.js-tab-body',
  activeClass: 'is-active',

  initEvents(context = document) {
    const section = context.querySelector(this.tabsSectionSelector);
    if (section === null) return;
    const titlesContainer = section.querySelector(this.tabsTitlesSelector);
    const bodiesContainer = section.querySelector(this.tabsBodiesSelector);
    const titles = titlesContainer.querySelectorAll(this.tabsTitleSelector);
    const bodies = bodiesContainer.querySelectorAll(this.tabsBodysSelector);

    titles.forEach((title, titleIndex) => {
      title.addEventListener('click', () => {
        bodies.forEach((body, bodyIndex) => {
          body.classList.toggle(this.activeClass, titleIndex === bodyIndex);
        });
      });
    });
  },

  init() {
    this.initEvents();

    document.addEventListener('shopify:section:load', () => {
      const section = event.target.querySelector(this.tabsSectionSelector);

      if (section === null) return;

      this.initEvents(event.target);
    });
  },
};
